var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"data-aos":"fade-right"}},[(_vm.templateNumber === 1)?_c('SingleImage1',{attrs:{"image":_vm.image}}):(_vm.templateNumber === 2)?_c('SingleImage2',{attrs:{"image":_vm.image}}):(_vm.templateNumber === 3)?_c('SingleImage4',{attrs:{"image":_vm.image}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }